export default (radValue) => (180 * radValue) / Math.PI;
